// import Heading from '@/components/atoms/Heading';
import Text from '@/components/atoms/Text';
import Quantity from '@/components/molecules/Quantity';
import Accordion from '@/components/atoms/Accordion';
import AccordionItem from '@/components/molecules/AccordionItem';
import * as S from './styles';
import { Fragment } from 'react';
import ProdutoPaginaMobileFallback from './fallback';

// import ScrollAreaContainer from '@/components/molecules/ScrollAreaContainer';
// import { theme } from '@/styles/theme';
// import Plano from '@/components/molecules/Plano';
import formatarHTML from '@/utils/formatarHTML';
import { useProdutoPageHookTypeReturn } from '../../hook/useProdutoPageHook';
import useMetodosUteis, {
  HTMLHigienizadoTag,
} from '@/hooks/useMetodosUteisHook';
// import { registrarEvento } from '@/services/googleAnalytics';
import GiftCardValoresGrid from '@/components/molecules/GiftCardValoresGrid';
import { Separator } from '@/components/atoms/Separator';
import PaginaVendaMobileTemplate from '@/components/templates/PaginaVendaMobileTemplate';

export default function ProdutoPaginaMobile(
  props: useProdutoPageHookTypeReturn,
) {
  const {
    produto,
    carregandoProduto,
    planoSelecionado,
    setPlanoSelecionado,
    adicionarProdutoASacola,
    // combosComOProduto,
    quantidadeProduto,
    setQuantidadeProduto,
    valorTotal,
    // visualizarTermosProduto,
    comprarAgora,
    resgastarCodigoAvulso,
    giftCardsValores,
    bannerDestaqueGiftCard,
  } = props;

  const { higienizarHTML } = useMetodosUteis();

  if (carregandoProduto || !produto) return <ProdutoPaginaMobileFallback />;

  return (
    <PaginaVendaMobileTemplate
      $bannerDestaqueImagem={bannerDestaqueGiftCard}
      $styleBannerImage={{
        height: 115,
      }}
      $breadcrumbPageTitle={produto?.nome ?? 'Assinatura'}
      $conteudoDescritivo={
        <Fragment>
          <S.Container>
            <S.ContainerEscolhaValor>
              <Text
                $size={2}
                $color="neutral"
                $weight="regular"
                $align="left"
                $highContrast={true}
                $text="Escolha o valor"
              />
              <GiftCardValoresGrid
                $planos={giftCardsValores}
                $planoSelecionado={planoSelecionado}
                $selecionarValor={setPlanoSelecionado}
              />
            </S.ContainerEscolhaValor>
            <Fragment>
              <S.ContainerQuantidade>
                <Text
                  $size={3}
                  $highContrast={true}
                  $text={'Quantidade'}
                  $align="left"
                  $weight="semibold"
                  $color="neutral"
                />
                <Quantity
                  $quantidade={quantidadeProduto}
                  $alterarQuantidade={setQuantidadeProduto}
                  $orientation="vertical"
                  $variant="ghost"
                  $desabilitarAlteracaoQuantidade={
                    Number(valorTotal || 0) === 0
                  }
                  $styleControles={{
                    padding: 0,
                  }}
                />
              </S.ContainerQuantidade>
              <Separator $block={false} $orientation="horizontal" />
              <Accordion $size={1} $style="bordered">
                <AccordionItem
                  $size={3}
                  $variant="ghost"
                  $disabled="off"
                  $title="Como utilizar"
                  $conteudo={
                    <S.ContainerDetalhesAccordion>
                      <HTMLHigienizadoTag
                        html={higienizarHTML(
                          formatarHTML(
                            giftCardsValores?.[planoSelecionado].comoUtilizar ??
                              '',
                          ),
                        )}
                      />
                    </S.ContainerDetalhesAccordion>
                  }
                />
              </Accordion>
              <Accordion $size={1} $style="bordered">
                <AccordionItem
                  $size={3}
                  $variant="ghost"
                  $disabled="off"
                  $title="Termos de uso"
                  $conteudo={
                    <S.ContainerDetalhesAccordion>
                      <HTMLHigienizadoTag
                        html={higienizarHTML(
                          formatarHTML(
                            giftCardsValores?.[planoSelecionado].termosDeUso ??
                              '',
                          ),
                        )}
                      />
                    </S.ContainerDetalhesAccordion>
                  }
                />
              </Accordion>
            </Fragment>
          </S.Container>
        </Fragment>
      }
      $valorTotal={valorTotal}
      $funcaoAdicionarAoCarrinho={adicionarProdutoASacola}
      $funcaoAcaoPrincial={() => {
        if (valorTotal === 0) {
          if (!produto?.planos) return;
          resgastarCodigoAvulso(giftCardsValores?.[planoSelecionado]?.id ?? '');
        } else {
          comprarAgora();
        }
      }}
      $textoBotaoAcaoPrincipal="Comprar agora"
    />
  );
}
